import { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import { motion } from 'framer-motion';

import { Loader } from './Loader';
import styles from './Loader.module.css';

interface LoaderBlockProps extends PropsWithChildren {
	isLoading?: boolean;
	relativeToParent?: boolean;
}

export const LoaderBlock: FC<LoaderBlockProps> = ({ children, isLoading, relativeToParent }) =>
	isLoading ? (
		<div
			className={classNames(
				styles[`loader__overlay--block`],
				relativeToParent && styles[`loader__overlay--relative`],
			)}
		>
			<motion.div
				className={styles[`loader__container--block`]}
				transition={{ duration: 0.2, easings: `easeInOut` }}
				initial={{ opacity: 1, transform: `scale(1.2)` }}
				animate={{ opacity: 1, transform: `scale(1)` }}
				exit={{ opacity: 0, transform: `scale(1.2)` }}
			>
				<Loader />
			</motion.div>
			{children}
		</div>
	) : (
		children
	);
